var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { NavLink, useResolvedPath } from 'react-router-dom';
import React from 'react';
import { useEditor } from '@smartfire/gutenberg-react';
import { isDev, useGlue, useLanguageCode } from '../../core';
import clsx from 'clsx';
const absoluteRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
export const Link = React.forwardRef((_a, ref) => {
    var { to, className = '', activeClassName = '', children } = _a, props = __rest(_a, ["to", "className", "activeClassName", "children"]);
    const { isEditing } = useEditor();
    const glue = useGlue();
    const [languageCode] = useLanguageCode();
    if (!isEditing && to) {
        if (isDev && props.target === '_blank' && !props.rel) {
            console.warn('You put a blank target without rel in this Glue UI Link Component, it could be a problem. Are you sure of doing this ?');
        }
        if (typeof to === 'string' && absoluteRegex.test(to)) {
            // It's an external link
            return (React.createElement("a", Object.assign({ ref: ref, className: className, href: to.toString() }, props), children));
        }
        else {
            // It's an internal link, handle by React Router
            let resolvedPath = useResolvedPath(to);
            // If translation are enabled and path start with /
            if (glue.isFrontTranslationEnabled() && resolvedPath.pathname.charAt(0) === '/') {
                // If language code is not in path we had in path
                if (!glue.frontAvailableLanguages.includes(resolvedPath.pathname.split('/')[1])) {
                    resolvedPath.pathname = '/' + languageCode + resolvedPath.pathname;
                }
            }
            return (React.createElement(NavLink, Object.assign({ ref: ref, to: resolvedPath, className: ({ isActive }) => clsx({
                    [className]: true,
                    [activeClassName]: isActive,
                }) }, props), children));
        }
    }
    else {
        // There is no link or we are in Gutenberg Editor
        return (React.createElement("a", Object.assign({ ref: ref, className: className, href: undefined }, props), children));
    }
});
//# sourceMappingURL=index.js.map